module.exports = __webpack_public_path__ + "assets/ic-huobi.d8ecf097.svg";